'use client';
import Image from 'next/image';
import imgFanClub from '@/assets/fan_club.jpg';
import imgBoy from '@/assets/boy_speaker.png';
import imgMeh from '@/assets/fanclub.jpg';
import { ChangeEvent, useState } from 'react';
import { validate } from 'indicative/validator';
import { toast } from 'react-toastify';
import { UploadFile } from '@/services/career.api';
import { JoinFanClub } from '@/services/auth.api';
import Select from 'react-select';
import { getErrorMessge } from '@/utils/helpers';

function Home() {
  const [formData, setFormData] = useState({
    name: '',
    sex: '',
    address: '',
    phone_number: '',
    dob: '',
    residentialAddress: '',
    city: '',
    hobby: '',
    nameOfSchool: '',
    class: '',
    schoolAddress: '',
    schoolcity: '',
    schoolState: '',
    parentFullname: '',
    parentPhoneNumber: '',
    parentgender: '',
    parentMaritalStatus: '',
  });
  const [error, setError] = useState({
    name: '',
    sex: '',
    address: '',
    phone_number: '',
    img: '',
    dob: '',
    residentialAddress: '',
    city: '',
    hobby: '',
    parentFullname: '',
    parentPhoneNumber: '',
    parentgender: '',
    parentMaritalStatus: '',
  });
  const [img, setImg] = useState<any>();
  const [loading, setLoading] = useState(false);

  const handleChange = (name: string, value: string) => {
    setFormData((preVal: any) => ({
      ...preVal,
      [name]: value,
    }));
  };

  const options = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ];

  const parentMaritalStatus = [
    { value: 'signle', label: 'Signle' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widow', label: 'Widow' },
  ];

  const apply = async (e: React.FormEvent) => {
    e.preventDefault();

    const file = new FormData();
    if (img) {
      file.append('file', img);
    }

    const validationRules = {
      name: 'required',
      sex: 'required',
      phone_number: 'required',
      address: 'required',
      dob: 'required',
      // residentialAddress: 'required',
      // city: 'required',
      // hobby: 'required',
      // parentFullname: 'required',
      // parentPhoneNumber: 'required',
      // parentgender: 'required',
      // parentMaritalStatus: 'required',
    };

    const validationMessages = {
      'name.required': 'Full name is required',
      'sex.required': 'Gender is required',
      'address.required': 'Address address is required',
      'phone_number.required': 'Phone number is required',
      'dob.required': 'date of birth is required',
      // 'residentialAddress.required': 'Residential address is required',
      // 'city.required': 'City is required',
      // 'hobby.required': 'Hobby is required',
      // 'parentFullname.required': 'Parent full name is required',
      // 'parentPhoneNumber.required': 'Parent Phone number is required',
      // 'parentgender.required': 'Parent Gender is required',
      // 'parentMaritalStatus.required': 'Parent marital status is required',
    };

    if (img === null || !img) {
      setError({ ...error, img: 'Image is required' });
      return;
    }

    validate(formData, validationRules, validationMessages)
      .then(() => {
        setError({
          name: '',
          sex: '',
          address: '',
          phone_number: '',
          img: '',
          dob: '',
          residentialAddress: '',
          city: '',
          hobby: '',
          parentFullname: '',
          parentPhoneNumber: '',
          parentgender: '',
          parentMaritalStatus: '',
        });
        handleUpload(file);
      })
      .catch((error) => {
        if (Array.isArray(error)) {
          const formattedErrors: any = {};
          error.forEach((err) => {
            formattedErrors[err.field] = err.message;
          });

          setError(formattedErrors);
        }
      });
  };

  const handleUpload = async (file: any) => {
    try {
      setLoading(true);
      const { data } = await UploadFile(file);
      const payload = {
        name: formData.name,
        sex: formData.sex,
        address: formData.address,
        phone_number: formData.phone_number,
        image_url: data.file_link,
        dob: data.dob,
      };
      const res = JoinFanClub(payload);

      setFormData({
        name: '',
        sex: '',
        address: '',
        phone_number: '',
        dob: '',
        residentialAddress: '',
        city: '',
        hobby: '',
        nameOfSchool: '',
        class: '',
        schoolAddress: '',
        schoolcity: '',
        schoolState: '',
        parentFullname: '',
        parentPhoneNumber: '',
        parentgender: '',
        parentMaritalStatus: '',
      });
      setImg(null);
      toast.success('Application Successfully sent!');
    } catch (err: any) {
      setLoading(false);
      const errMessage = getErrorMessge(err);
      toast.error(errMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section>
        <Image src={imgFanClub} alt="fan club image" className="w-full" />
      </section>
      <section className="flex flex-col">
        <ul className="flex w-full">
          <li className="w-full lg:basis-[80%] basis-full shrink-0 grow-0 lg:px-24 px-6 py-16 ">
            <div className="flex flex-col gap-0">
              <h1 className="text-4xl font-bold">
                Be a Crunchies <br />
                Fanclubber
              </h1>
              <small>
                Fill in the form below and we will call you after confirmation
              </small>
            </div>
            <form
              action=""
              className="flex w-full  flex-row flex-wrap gap-8 py-8"
            >
              <h2 className="w-full">PERSONAL INFORMATION</h2>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="Full name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full  rounded-lg px-3 py-2 outline-0"
                />
                {error.name && (
                  <p className="text-sm  text-primary-500">{error.name}</p>
                )}
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="date"
                  placeholder="Date of birth"
                  name="dob"
                  value={formData.dob}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full  rounded-lg px-3 py-2 outline-0"
                />
                {error.dob && (
                  <p className="text-sm  text-primary-500">{error.dob}</p>
                )}{' '}
              </div>
              <div className="w-full md:w-[300px]">
                <Select
                  options={options}
                  placeholder="Select Gender"
                  value={options.find(
                    (option) => option.value === formData.sex
                  )}
                  className="w-full  py-1"
                  name="sex"
                  onChange={(selectedOption) =>
                    handleChange('sex', selectedOption?.value as string)
                  }
                />
                {error.sex && (
                  <p className="text-sm  text-primary-500">{error.sex}</p>
                )}{' '}
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="Residential Address"
                  name="address"
                  value={formData.address}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
                {error.address && (
                  <p className="text-sm  text-primary-500">{error.address}</p>
                )}{' '}
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="City"
                  name="city"
                  value={formData.city}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
                {error.city && (
                  <p className="text-sm  text-primary-500">{error.city}</p>
                )}{' '}
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="Hobby"
                  name="hobby"
                  value={formData.hobby}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
                {error.hobby && (
                  <p className="text-sm  text-primary-500">{error.hobby}</p>
                )}{' '}
              </div>
              <div className="w-full ">
                <label className="w-full flex pb-3">Upload Profile image</label>
                <input
                  type="file"
                  id="fullname"
                  name="address"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setImg(e.target.files?.length ? e.target.files[0] : null)
                  }
                  className="outline-0 grow text-sm"
                  placeholder="Upload an image Jpg, jpeg, png %mb"
                />
                {error.img && (
                  <p className="text-sm  text-primary-500">{error.img}</p>
                )}{' '}
              </div>
              <h2 className="w-full">SCHOOL DETAILS</h2>
              <div className="w-full md:w-[300px]">
                {' '}
                <input
                  type="text"
                  placeholder="Name of school"
                  name="nameOfSchool"
                  value={formData.nameOfSchool}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="Class"
                  name="class"
                  value={formData.class}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full  rounded-lg px-3 py-2 outline-0"
                />
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="School Address"
                  name="schoolAddress"
                  value={formData.schoolAddress}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full  rounded-lg px-3 py-2 outline-0"
                />
              </div>
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="City"
                  name="nameOfSchool"
                  value={formData.schoolcity}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />{' '}
              </div>{' '}
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="State"
                  name="schoolState"
                  value={formData.schoolState}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full  rounded-lg px-3 py-2 outline-0"
                />
              </div>
              <h2 className="w-full">PARENT/GUARDIAN/SPONSOR`S INFORMATION </h2>{' '}
              <div className="w-full md:w-[300px]">
                <input
                  type="text"
                  placeholder="Parent Full name"
                  name="parentFullname"
                  value={formData.parentFullname}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
                {error.parentFullname && (
                  <p className="text-sm  text-primary-500">
                    {error.parentFullname}
                  </p>
                )}{' '}
              </div>{' '}
              <div className="w-full md:w-[300px]">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  className="border w-full rounded-lg px-3 py-2 outline-0"
                />
                {error.phone_number && (
                  <p className="text-sm  text-primary-500">
                    {error.phone_number}
                  </p>
                )}{' '}
              </div>{' '}
              <div className="w-full md:w-[300px]">
                <Select
                  options={options}
                  placeholder="Select Parent Gender"
                  value={options.find(
                    (option) => option.value === formData.parentgender
                  )}
                  className="w-full "
                  name="parentgender"
                  onChange={(selectedOption) =>
                    handleChange(
                      'parentgender',
                      selectedOption?.value as string
                    )
                  }
                />{' '}
              </div>{' '}
              <div className="w-full md:w-[300px]">
                <Select
                  options={parentMaritalStatus}
                  placeholder="Marital Status"
                  value={options.find(
                    (option) => option.value === formData.parentMaritalStatus
                  )}
                  className="w-full "
                  name="parentMaritalStatus"
                  onChange={(selectedOption) =>
                    handleChange(
                      'parentMaritalStatus',
                      selectedOption?.value as string
                    )
                  }
                />
                {error.parentMaritalStatus && (
                  <p className="text-sm  text-primary-500">
                    {error.parentMaritalStatus}
                  </p>
                )}
              </div>
              <div className="w-full  mt-14">
                <button
                  type="submit"
                  onClick={apply}
                  className="px-24 py-3 w-full md:w-fit  font-semibold rounded-full bg-primary-500 text-sm text-white"
                >
                  {loading ? 'Loading...' : 'Submit'}
                </button>
              </div>
            </form>
          </li>
          <li className="hidden relative lg:flex grow-0">
            <Image
              src={imgBoy}
              alt="image of boy"
              className="w-full object-contain object-right-bottom"
            />
          </li>
        </ul>
      </section>
      <section>
        <Image
          src={imgMeh}
          alt="image of boy"
          className="w-full object-contain object-right-bottom"
        />
      </section>
    </>
  );
}

export default Home;
